<template>
    <div class="nav-bar-maintenance">
      <img
        src="@/assets/logogruas.png"
        alt="HomePage"
        @click="backMainPanel"
        class="logo-button"
      />
    </div>
  
    <main class="page">
      <header class="page-header">
        <div>
          <h2>Clientes</h2>
          <p class="subtitle">Tabla de clientes con filtros por columna.</p>
        </div>
  
        <div class="actions">
          <button v-if="canAccessGroupedBilling" @click="groupedBilling" class="btn btn-primary">
            Facturación agrupada
          </button>
          <button v-if="canAccessInvoiceMaster" @click="invoiceSearch" class="btn btn-ghost">
            Maestro de facturas
          </button>
        </div>
      </header>
  
      <section class="table-section">
        <div class="table-head">
          <h3>Tabla de clientes</h3>
  
          <div class="meta">
            <span class="chip">Total: <b>{{ n_clients }}</b></span>
            <span class="chip">Página <b>{{ currentPage }}</b> / <b>{{ totalClientsPages }}</b></span>
          </div>
        </div>
  
        <div v-if="!canViewClientsTable" class="no-access">
          No tienes permisos para ver el listado de clientes.
        </div>
        <div v-if="canViewClientsTable" class="table-wrap">
          <table class="table">
            <!-- column widths (desktop) -->
            <colgroup>
              <col style="width: 160px" /> <!-- Numero de Cliente -->
              <col style="width: 260px" /> <!-- Nombre -->
              <col style="width: 160px" /> <!-- Teléfono -->
              <col style="width: 240px" /> <!-- Dirección -->
              <col style="width: 170px" /> <!-- RFC -->
              <col style="width: 130px" /> <!-- Estatus -->
              <col style="width: 140px" /> <!-- Tipo -->
              <col style="width: 220px" /> <!-- Régimen fiscal -->
            </colgroup>
  
            <thead>
              <tr class="head-row">
                <th>Número de Cliente</th>
                <th>Nombre</th>
                <th>Teléfono</th>
                <th>Dirección</th>
                <th>RFC</th>
                <th>Estatus</th>
                <th>Tipo</th>
                <th>Régimen fiscal</th>
              </tr>
  
              <tr class="filter-row">
                <th><input v-model="filters.client_ident" @input="applyFiltersUnit" placeholder="Buscar número" /></th>
                <th><input v-model="filters.client_name" @input="applyFiltersUnit" placeholder="Buscar nombre" /></th>
                <th><input v-model="filters.phone" @input="applyFiltersUnit" placeholder="Buscar teléfono" /></th>
                <th><input v-model="filters.client_address" @input="applyFiltersUnit" placeholder="Buscar dirección" /></th>
                <th><input v-model="filters.client_rfc" @input="applyFiltersUnit" placeholder="Buscar RFC" /></th>
                <th><input v-model="filters.client_status" @input="applyFiltersUnit" placeholder="Buscar estatus" /></th>
                <th><input v-model="filters.is_privileged" @input="applyFiltersUnit" placeholder="Regular/Particular" /></th>
                <th><input v-model="filters.tax_regime" @input="applyFiltersUnit" placeholder="Buscar régimen fiscal" /></th>
              </tr>
            </thead>
  
            <tbody>
              <tr
                v-for="(client, index) in paginatedClients"
                :key="index"
                class="row"
                @click="viewClientDetails(client.client_name, client.id)"
                title="Click para ver detalles"
              >
                <td><span class="id-pill">{{ client.client_ident }}</span></td>
                <td class="name">{{ client.client_name }}</td>
                <td class="mono">{{ client.phone }}</td>
                <td class="addr">
                  {{ client.client_address.city }}, {{ client.client_address.state }}
                </td>
                <td class="mono">{{ client.client_rfc }}</td>
  
                <td>
                  <span
                    class="status"
                    :class="{
                      'is-active': client.client_status === 'Activo',
                      'is-inactive': client.client_status === 'Inactivo'
                    }"
                  >
                    {{ client.client_status }}
                  </span>
                </td>
  
                <td>
                  <span
                    class="tag"
                    :class="{
                      'is-regular': client.is_privileged === true,
                      'is-particular': client.is_privileged === false
                    }"
                  >
                    {{ client.is_privileged === true ? 'Regular' : (client.is_privileged === false ? 'Particular' : client.is_privileged) }}
                  </span>
                </td>
  
                <td>{{ client.tax_regime }}</td>
              </tr>
            </tbody>
          </table>
        </div>
  
        <div v-if="canViewClientsTable" class="pagination">
          <button class="icon-btn" @click="prevPage" :disabled="currentPage === 1">
            <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
          </button>
  
          <div class="pages">
  <span
    v-for="(p, i) in visiblePages"
    :key="i"
    class="page-pill"
    :class="{ active: p === currentPage, ellipsis: p === '...' }"
    @click="p !== '...' && goToPage(p)"
  >
    {{ p }}
  </span>
</div>
  
          <button class="icon-btn" @click="nextPage" :disabled="currentPage >= totalClientsPages">
            <img src="@/assets/angulo-derecho.png" alt="Next Page" />
          </button>
        </div>
      </section>
    </main>
  </template>

<style scoped>
:root{
  --bg: #f6f7f9;
  --surface: #ffffff;
  --surface-2: #fbfbfc;
  --border: #e3e6ea;
  --text: #1f2937;
  --muted: #6b7280;
  --shadow: 0 10px 25px rgba(0,0,0,.08);
  --radius: 16px;
  --brand: #FFC434;
  --brand-soft: rgba(255,196,52,.22);
}

*{ box-sizing: border-box; }
body{
  margin: 0;
  background: var(--bg);
  color: var(--text);
  font-family: system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Ubuntu,"Helvetica Neue",Arial;
}

/* top bar */
.nav-bar-maintenance{
  position: fixed;
  top: 0; left: 0;
  width: 100vw;
  height: 64px;
  background-color: var(--brand);
  z-index: 1000;
}
.logo-button{
  position: absolute;
  height: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  margin: 0;
}

/* page */
.page{
  max-width: 1500px;
  margin: 0 auto;
  padding: 86px 16px 24px;
}

.page-header{
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 12px;
}
.page-header h2{
  margin: 0;
  font-size: 22px;
  font-weight: 900;
}
.subtitle{
  margin: 6px 0 0;
  font-size: 13px;
  color: var(--muted);
}

.actions{
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* buttons */
.btn{
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text);
  padding: 10px 14px;
  border-radius: 14px;
  font-weight: 800;
  font-size: 13px;
  cursor: pointer;
  transition: transform .06s ease, filter .15s ease, background .15s ease;
}
.btn:hover{ background: var(--surface-2); }
.btn:active{ transform: translateY(1px); }

.btn-primary{
  background: linear-gradient(180deg, #FFD36B 0%, #FFC434 100%);
  border-color: rgba(0,0,0,.12);
  color: #151515;
  box-shadow: 0 10px 20px rgba(255,196,52,.18);
}
.btn-primary:hover{ filter: brightness(.97); }

.btn-ghost{
  background: transparent;
}

/* section */
.table-section{ margin-top: 8px; }

.table-head{
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 4px;
  border-bottom: 1px solid var(--border);
}
.table-head h3{
  margin: 0;
  font-size: 15px;
  font-weight: 900;
}
.meta{ display: flex; gap: 8px; }
.chip{
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
}

/* table base */
.table-wrap{ overflow: visible; margin-top: 8px; }
.table{
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  font-size: 13px;
}
.table th, .table td{
  padding: 12px 10px;
  border-bottom: 1px solid rgba(227,230,234,.9);
  text-align: left;
  vertical-align: middle;
}

/* sticky header + filter */
.head-row th{
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f3f4f6;
  color: var(--muted);
  font-size: 12px;
  font-weight: 900;
  letter-spacing: .3px;
  border-top: 1px solid var(--border);
}
.filter-row th{
  position: sticky;
  top: 42px;
  z-index: 1;
  background: #ffffff;
  padding-top: 8px;
  padding-bottom: 10px;
}
.table thead input{
  width: 100%;
  height: 34px;
  padding: 0 10px;
  border-radius: 12px;
  border: 1px solid #d7dbe0;
  outline: none;
  font-size: 13px;
  background: #fff;
}
.table thead input:focus{
  border-color: rgba(255,196,52,.9);
  box-shadow: 0 0 0 3px rgba(255,196,52,.22);
}

/* rows */
.row{ cursor: pointer; }
.row:hover td{ background: #fafafa; }

.name, .addr{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mono{ font-variant-numeric: tabular-nums; }

/* id pill */
.id-pill{
  display: inline-flex;
  padding: 6px 10px;
  border-radius: 999px;
  background: var(--brand-soft);
  border: 1px solid rgba(255,196,52,.35);
  font-weight: 900;
  color: #111827;
}

/* status pills */
.status, .tag{
  display: inline-flex;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #f3f4f6;
  font-size: 12px;
  font-weight: 800;
}

/* Activo/Inactivo */
.status.is-active{
  background: rgba(16,185,129,.12);
  border-color: rgba(16,185,129,.28);
  color: #065f46;
}
.status.is-inactive{
  background: rgba(239,68,68,.12);
  border-color: rgba(239,68,68,.28);
  color: #7f1d1d;
}

/* Regular/Particular */
.tag.is-regular{
  background: rgba(147,51,234,.12);
  border-color: rgba(147,51,234,.28);
  color: #5b21b6;
}
.tag.is-particular{
  background: rgba(37,99,235,.12);
  border-color: rgba(37,99,235,.28);
  color: #1e3a8a;
}

/* pagination */
.pagination{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 0 0;
}
.icon-btn{
  width: 42px;
  height: 42px;
  border-radius: 14px;
  border: 1px solid var(--border);
  background: var(--surface);
  display: grid;
  place-items: center;
  padding: 0;
  cursor: pointer;
  flex: 0 0 auto;
}
.icon-btn:disabled{ opacity: .45; cursor: not-allowed; }
.icon-btn img{ width: 20px; height: 20px; object-fit: contain; display: block; }

.pages{
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 70vw;
}
.page-pill{
  user-select: none;
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: #fff;
  font-size: 12px;
  font-weight: 800;
}
.page-pill.active{
  background: rgba(255,196,52,.25);
  border-color: rgba(255,196,52,.45);
}

/* =========================
   HARD RESET: enforce real table layout (fix stacked letters)
   ========================= */
.table-wrap table.table { display: table !important; width: 100% !important; }
.table-wrap thead { display: table-header-group !important; }
.table-wrap tbody { display: table-row-group !important; }
.table-wrap tr { display: table-row !important; }
.table-wrap th,
.table-wrap td { display: table-cell !important; }

/* kill any old width rules */
.table-wrap th,
.table-wrap td { width: auto !important; }

/* prevent “one-letter-per-line” */
.table-wrap th,
.table-wrap td{
  word-break: normal !important;
  overflow-wrap: normal !important;
}

.page-pill.ellipsis{
  cursor: default;
  opacity: .6;
  background: transparent;
  border-color: transparent;
}
.page-pill.ellipsis:hover{
  background: transparent;
}

.no-access {
  text-align: center;
  padding: 18px 12px;
  color: #8a3b00;
  background: #fff6e5;
  border: 1px solid #f2dfb2;
  border-radius: 10px;
  margin-bottom: 12px;
}
</style>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
    data() {
        return {
            permissions: [],
            currentPage: 1,
            pageSize: 12,
            clients : [],
            n_clients: 0,
            filters: {
                client_ident: '',
                client_name: '',
                phone: '',
                client_address: '',
                client_rfc: '',
                client_status: '',
                is_privileged: '',
                tax_regime: ''
            },
            originalClients: []
        }
    },
    computed: {
        canViewClientsTable() {
            return this.hasAnyPerm(['accounting.view_clients_table'])
        },
        canViewClientDetail() {
            return this.hasAnyPerm(['accounting.view_client_detail'])
        },
        canAccessInvoiceMaster() {
            return this.hasAnyPerm(['accounting.view_invoice_master'])
        },
        canAccessGroupedBilling() {
            return this.hasAnyPerm(['accounting.view_grouped_billing'])
        },
        paginatedClients() {
            return this.clients
        },
        totalClientsPages() {
            return Math.ceil(this.n_clients / this.pageSize);
        },

        visiblePages() {
    const total = this.totalClientsPages; // or totalEmployeesPages / totalUnitsPages depending on component
    const current = this.currentPage;

    const windowSize = 5; // how many pages to show around current
    const pages = [];

    if (total <= 1) return pages;

    const start = Math.max(1, current - windowSize);
    const end = Math.min(total, current + windowSize);

    // always show first
    pages.push(1);

    // left ellipsis
    if (start > 2) pages.push('...');

    // middle window (excluding 1 and last)
    for (let p = start; p <= end; p++) {
      if (p !== 1 && p !== total) pages.push(p);
    }

    // right ellipsis
    if (end < total - 1) pages.push('...');

    // always show last
    if (total > 1) pages.push(total);

    // de-dupe in case total small
    return pages.filter((v, i, arr) => i === 0 || v !== arr[i - 1]);
  }
    },
    mounted() {
        this.loadPermissions()
        if (!this.canViewClientsTable) {
            Swal.fire('Sin acceso', 'No tienes permisos para ver clientes.', 'warning')
            this.$router.push({ path: '/main-panel' })
            return
        }
        this.fetchClients();
    },
    methods: {
        loadPermissions() {
            try {
                this.permissions = JSON.parse(localStorage.getItem('userPermissions')) || []
            } catch (error) {
                this.permissions = []
            }
        },
        hasPerm(perm) {
            if (!perm) return false
            if (this.permissions.includes(perm)) return true
            return this.permissions.includes(`access_control.${perm}`)
        },
        hasAnyPerm(perms) {
            if (!Array.isArray(perms) || perms.length === 0) return false
            return perms.some((perm) => this.hasPerm(perm))
        },
        backMainPanel() {
            window.location.href = '/main-panel';
        },
        addUnit() {
            window.location.href = '/agregar-nueva-unidad';
        },
        invoiceSearch() {
            if (!this.canAccessInvoiceMaster) {
                Swal.fire('Sin acceso', 'No tienes permisos para ver el maestro de facturas.', 'warning')
                return
            }
            window.location.href = '/maestro-facturas';
        },
        groupedBilling() {
            if (!this.canAccessGroupedBilling) {
                Swal.fire('Sin acceso', 'No tienes permisos para facturación agrupada.', 'warning')
                return
            }
            window.location.href = '/facturar-agrupadas';
        },
        forkliftGroupedBilling() {
            window.location.href = '/facturar-agrupadas-montacargas';
        },
        goToPage(pageNumber) {
            this.currentPage = pageNumber;
            const page = this.currentPage
            this.fetchClients(page);
        },
        async fetchClients(page = 1) {
            /**Fetches the in process notes using the provided filters*/
            let response
            const apiDirectory = process.env.API_DIRECTORY;

            try {
                if (!this.canViewClientsTable) {
                    return
                }
                response = await axios.post(`${apiDirectory}/get-client?page=${page}&page_size=${this.pageSize}`,this.filters)
                const responseData = response.data.results;
                this.clients = responseData
                this.n_clients = response.data.count
                this.originalClients = [...responseData]
            }
            catch (error) {
                console.error('Error fetching data from API:', error)
            }
        },
        nextPage() {
            if (this.currentPage < this.totalClientsPages) this.currentPage++;
            const page = this.currentPage
            this.fetchClients(page);
        },
        prevPage() {
            if (this.currentPage > 1) this.currentPage--;
            const page = this.currentPage
            this.fetchClients(page);
        },
        applyFiltersUnit() {
            this.fetchClients()
        },
        viewClientDetails(client_name, client_id) {
            if (!this.canViewClientDetail) {
                Swal.fire('Sin acceso', 'No tienes permisos para ver el cliente.', 'warning')
                return
            }
            Swal.fire({
                title: '¿Estás seguro?',
                text: `¿Quieres ver los detalles del cliente ${client_name}?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, ver detalles',
                cancelButtonText: 'No, cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$router.push({ name: 'EditClient', params: { client_id } });
                }
            });
        },
    }
}
</script>